import type { FaireProductEntity } from "../../entity_types/product";

export const p_ewyk94sybn: FaireProductEntity = {
  token: "p_ewyk94sybn",
  type: "product",
  name: "Organic Bamboo Socks",
  brandToken: "b_685mypxyu2",
  brandName: "Fabina",
  imageUrl:
    "https://cdn.faire.com/fastly/fe71dde1b5b275319440ed6fc6c63c364f1154ddd42f491d588fb0ba777137c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c0623187486fdf33bd4b50b3cd2134224fb0edd23a7a8a83605f18bb36d15d7.jpeg",
    "https://cdn.faire.com/fastly/0d0e6c199256f0a1909a1e1e278fb920d9725a4eb0baa34bd4b3c67287b3fc38.jpeg",
    "https://cdn.faire.com/fastly/21caff60374a8d37523e670da16572c8d69276f2e92932478adabce7d4d5e669.jpeg",
    "https://cdn.faire.com/fastly/948d3a6a1f3d07262a23eed5e1e8c510b0eeb996ddd1c8c3a44106b96a1583a6.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Bamboo socks with organic cotton blended rib\n\n• One size\n• 5 colors with 4 pairs each color\n• Total 20 pairs.\n\n• Cream Tan Mauve Olive Grey",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:41.641Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
